export class Swiper3D {
  constructor(difference) {
    this.styleId = 1
    this.width = 500
    this.widthType = "px"
    this.height = 600
    this.heightType = "px"
    this.top = 0
    this.left = 0
    this.iframeUrl = "https://vr.chaoxing.com/#/showCustomerSpace?id=MTI3MQ==&&type=cus&isPt&specialSwipe2"
    this.rotate = 0
    this.innerElement = "cxSwiper3D"
    this.iframeScrollStatus = false
    this.usePageQuery = false //页面传参
    this.loop = true
    this.autoPlay = true
    this.autoPlayDelay = 3
    this.dataList = [
      {
        swiperContent_id: 0,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/origin/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100,
        linkUrl: ''
      },
      {
        swiperContent_id: 1,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/origin/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100,
        linkUrl: ''
      },
      {
        swiperContent_id: 2,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100,
        linkUrl: ''
      }
      // {
      //   type: "video",
      //   label: "视频",
      //   imgUrl: "https://pan-yz.chaoxing.com/thumbnail/origin/0a374016a5444b50b2eafde26a66f463?type=video",
      //   videoCache: true,
      //   loopPlay: true,
      //   autoplay: true,
      //   objectId: "0a374016a5444b50b2eafde26a66f463"
      // }
    ]
    this.fadeEffect = {
      crossFade: true
    }
    this.cubeEffect = {
      slideShadows: true,
      shadow: true,
      shadowOffset: 100,
      shadowScale: 0.6
    }
    this.coverflowEffect = {
      rotate: 15,
      stretch: 0,
      depth: 70,
      modifier: 2,
      slideShadows: true
    }
    this.flipEffect = {
      slideShadows: true,
      limitRotation: true
    }
    this.bulletsSize = 20
    this.bulletsMargin = 10
    this.rectangleWidth = 20
    this.rectangleHeight = 20
    this.rectangleActiveWidth = 20
    this.rectangleActiveHeight = 20
    this.paginationPosition = "bottom"
    this.progressbarBackground = "rgb(0,122,255)"
    this.pagination = {
      type: "bullets", //‘bullets’  圆点（默认）,‘fraction’  分数， ‘progressbar’  进度条
      clickable: true, //点击切换,
      bulletsPrimaryColor: "rgba(0,0,0,0.2)",
      bulletsActiveColor: "rgb(0,122,255)"
    }
    this.progressbarIsTheme = false
    this.direction = "horizontal"
    this.borderStyle = "solid"
    this.borderWidth = 0
    this.boxShadowColor = []
    this.boxShadowH = []
    this.boxShadowV = []
    this.boxShadowBlur = []
    this.boxShadowSpread = []

    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
